import React from 'react';
import { useDashboardCounts, getStatsArray } from './DashboardData';
import './index.scss';

const Dashboard = () => {
    const { counts, isLoading } = useDashboardCounts();
    const stats = getStatsArray(counts, isLoading);

    return (
        <div className="dashboard-page">
            <h1 className="page-title">Dashboard</h1>

            <div className="stats-grid">
                {stats.map((stat, index) => (
                    <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
                        <div className="stat-icon" style={{ background: `${stat.color}20` }}>
                            <span>{stat.icon}</span>
                        </div>
                        <div className="stat-content">
                            <h3 className={`stat-value ${isLoading ? 'loading' : ''}`}>
                                {stat.value}
                            </h3>
                            <p className="stat-title">{stat.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};



export default Dashboard;
